import type { JWT } from 'aws-amplify/auth';
import type { KeycloakTokenParsed } from 'keycloak-js';

import { Country, KDSPermission, Kitchen } from './index';
import type { CognitoUser } from './interfaces';
import { keycloakCaller } from '../../../libs/auth/keycloakClaims';

export type AuthUser = { provider: 'cognito'; claims: JWT['payload'] } | { provider: 'keycloak'; claims: KeycloakTokenParsed };

const text = (value: unknown) => (typeof value === 'string' ? value : '');

export const parseKeycloakUser = (claims: KeycloakTokenParsed): CognitoUser => {
  const caller = keycloakCaller(claims);
  if (!caller) {
    throw new Error('Invalid Keycloak access token');
  }
  const kitchen = Object.values(Kitchen).filter((value) => caller.account.kitchens.includes(value));
  return {
    id: caller.sub,
    name: text(claims.name) || text(claims.preferred_username),
    email: text(claims.email),
    phoneNumber: text(claims.phone_number),
    kitchen,
    country: Object.values(Country).find((value) => kitchen[0]?.startsWith(value)) ?? Country.BH,
    group: '',
    permissions: Object.values(KDSPermission).filter((value) => caller.account.permissions.includes(value))
  };
};
